export default "__VITE_ASSET__DV15RsyA__"